<template>
  <modal
    :name="name"
    @before-open="beforeOpen"
    :width="width"
    :height="height"
    @before-close="beforeClose"
    class="option-config-container"
  >
    <div class="params-header">
      <div class="option-title">{{ values && (values.name || (values.view && values.view.name))  || 'General Characteristics'}}</div>
      <div class="modal-actions">
        <div class="btn btn--primary" @click="close">Cancel</div>
        <div class="btn btn--primary" @click="doSave">Save</div>
      </div>
    </div>
    <option-config v-if="paramConfig" :optionType="paramConfig.optionType" :values="values" :colorScale="paramConfig.colorScale" :markedSegments="markedSegments"></option-config>
  </modal>
</template>

<script>
import OptionConfig from '@/components/OptionConfig'

export default {
  name: 'ModalOptionConfig',
  components: {OptionConfig},
  props: ['name', 'width', 'height'],
  data () {
    return {
      paramConfig: null,
      values: null,
      markedSegments: []
    }
  },
  computed: {
    

  },
  methods: {
    beforeOpen(event) {
      this.paramConfig = event.params.paramConfig
      this.values = event.params.values
      this.markedSegments = event.params.markedSegments || []
    },
    beforeClose(event) {
      document.body.style.cursor = "default"
    },
    doSave(){
      // let result = this.extractValues(this.values)
      // console.log("should POST",result)
      this.$emit('save',{paramConfig: this.paramConfig, value:this.values})
      this.$modal.hide(this.name)
    },
    close(){
      this.$modal.hide(this.name)
    }
  }
}
</script>

<style lang="stylus" scoped>
.option-config-container
  background-color: rgba(#000, 0.5)
  display: flex
  height: 100%
  width: 100%

  >>> .vm--modal
    background: rgb(239, 239, 242)
    background: linear-gradient(180deg, rgba(239, 239, 242, 1) 0, rgba(206, 208, 217, 1) 100%)
    display: flex
    flex-direction: column

  .params-header
    display: flex
    margin: 10px 20px
    align-items: baseline
    .modal-actions
      margin-left: auto
      display flex
      max-height 32px


  .option-title
    m-font-size(28, 32)
    font-weight: $fw-light
    overflow-wrap: anywhere

  .section-title
    m-font-size(16, 18)
    color: $gull-gray
    font-weight: $fw-light
    text-transform: uppercase
</style>